import { required, email } from 'vuelidate/lib/validators';
import { dataListPasswordChange, dataListStatusMerchant } from '../../store/params';
import { date, showAlert } from '../../lib/helpers';
import { headers, search } from './attributes';


export default {
  validations: {
    editedItem: {
      username: {
        required,
        email,
        isUnique() {
          return (
            this.errorValidation != null &&
            (this.errorValidation.username == null ||
              this.errorValidation.username.length < 1)
          );
        },
      },
    },
  },
  data: () => ({
    search,
    dataListStatusMerchant,
    dateMenu: false,
    dateMenuLastLogin: false,
    dateFormatted: '',
    dateFormattedLastLogin: '',
    show: false,
    view: false,
    limit: '5',
    page: '1',
    options: {},
    dialog: false,
    headers,
    editedIndex: -1,
    changePassword: true,
    editedItem: {
      username: '',
    },
    defaultItem: {
      username: '',
    },
    selectedRow: '',
    listPasswordChange: dataListPasswordChange,
    dialogConfirm: false,
    selectedData : {},
  }),

  computed: {
  
    formTitle() {
      let item = '';
      if (this.editedIndex !== -1) {
        if (this.editedIndex === -2) {
          item = 'View Merchant';
        } else item = 'Edit Merchant';
      } else item = 'New Merchant';
      return item;
    },
    flashErrorMessage() {
      return this.$store.state.merchantManagement.flashErrorMessage;
    },

    flashError: {
      get() {
        return this.$store.state.merchantManagement.flashError;
      },
      set() {
        this.$store.commit('merchantManagement/setFlashErrorMessage', '');
      },
    },

    errorValidation() {
      return this.$store.state.merchantManagement.errors;
    },
    loading() {
      return this.$store.state.merchantManagement.loading;
    },
    users() {
      return this.$store.state.merchantManagement.allUsers;
    },
    totalUsers() {
      return this.$store.state.merchantManagement.totalUsers;
    },
    totalPage() {
      return this.$store.state.merchantManagement.totalPage;
    },
    isDisabledBlock() {
      return this.$store.state.merchantManagement.isDisabledBlock;
    },
    usernameErrors() {
      const errors = [];
      if (!this.$v.editedItem.username.$dirty) return errors;
      if (!this.$v.editedItem.username.email)
        errors.push('Must be valid e-mail');
      if (!this.$v.editedItem.username.required)
        errors.push('E-mail is required');
      if (!this.$v.editedItem.username.isUnique) {
        if (
          this.errorValidation != null &&
          this.errorValidation.username != null
        ) {
          this.errorValidation.username.forEach((item) => {
            errors.push(item);
          });
        }
      }
      return errors;
    },
  },

  watch: {
    dialog(val) {
      if (!val) this.close();
    },
    options: {
      handler() {
        this.getData();
      },
      deep: true,
    },

    'search.created_at': {
      handler() {
        this.dateFormatted = this.formatDate(this.search.created_at);
        this.getData();
      },
    },

    'search.last_login_at': {
      handler() {
        this.dateFormattedLastLogin = this.formatDate(
          this.search.last_login_at
        );
        this.getData();
      },
    },

    'editedItem.username': {
      handler(val) {
        if (this.errorValidation != null) {
          if (
            this.errorValidation.username != null &&
            val !== this.errorValidation.username
          ) {
            this.$store.commit(
              'merchantManagement/clearErrorVariable',
              'username'
            );
          }
        }
      },
    },

    show() {
      if (!this.show) {
        this.search.username = '';
        this.search.mid = '';
        this.search.last_login_at = '';
        this.search.created_at = '';
        this.search.password_change = '';
        this.$nextTick(() => {
          this.getData();
        });
      }
    },
  },

  methods: {
    getStatusLabel(status) {
      const statusMap = {
        '0': 'Inactive',
        '1': 'Active',
        '2': 'Blocked',
        '3': 'Dormant',
        '4': 'Deleted'
      };

      return statusMap[status] || '';
    },
    getConfirmationText(status) {
      if (status === 'active') {
        return 'Block User';
      } 
      if (status === 'blocked') {
        return 'Unblock User';
      }
      return '';
    },
    getDialogTitle(status) {
      if (status === 'active') {
        return 'Apakah anda yakin ingin memblokir user ini ?';
      } 
      if (status === 'blocked') {
        return 'Apakah anda yakin ingin membuka blokir user ini ?';
      }
      return '';
    },
    closeDialogConfirm() {
      this.dialogConfirm = false;
      this.selectedRow = '';
    },

    handleBlockUnblock(item) {
      this.dialogConfirm = true;
      this.editedItem = item;
      this.selectedData = item;
    },
    getActionIcon(status) {
      if (status === 'active') {
        return 'mdi-lock';
      } 
      if (status === 'blocked') {
        return 'mdi-lock-open-outline';
      }
      return '';

    },
    getActionLabel(status) {
      if (status === 'active') {
        return 'Block User';
      } 
      if (status === 'blocked') {
        return 'Unblock User';
      }
      return '';
    },

    async handleBlockUser() {
      this.dialogConfirm = false;
      const idData = this.selectedData.id;

      try {
        const res = await this.$store.dispatch('merchantManagement/blockUser', {
          id: idData,
          date,
        });

        if (res !== false){
          this.getData();
        }

      } catch (error) {
        showAlert(
          this.$store,
          'Something Went Wrong !', 'mdi-alert', 'red'
        );
      }
    },
    async handleUnBlockUser() {
      this.dialogConfirm = false;
      const idData = this.selectedData.id;

      try {
        const res = await this.$store.dispatch('merchantManagement/unBlockUser', {
          id: idData,
          date,
        });

        if (res !== false){
          this.getData();
        }

      } catch (error) {
        showAlert(
          this.$store,
          'Something Went Wrong !', 'mdi-alert', 'red'
        );
      }
    },


    confirmAction() {
      if (this.selectedData.status === 'active') {
        this.handleBlockUser();
      } else if (this.selectedData.status === 'blocked') {
        this.handleUnBlockUser();
      }
    },
    selectRow(index) {
      if (this.selectedRow !== index) {
        this.selectedRow = index;
      } else {
        this.selectedRow = '';
      }
    },

    rowClass() {
      const rowClass = 'max-width-col';
      return rowClass;
    },

    clearSearch() {
      this.search.username = '';
      this.search.mid = '';
      this.search.last_login_at = '';
      this.search.created_at = '';
      this.search.password_change = '';
      this.search.status = '';
      this.getData();
    },

    formatDate(dateVal) {
      if (!dateVal) return null;

      const [year, month, day] = dateVal.split('-');
      return `${day}/${month}/${year}`;
    },
    parseDate(dateVal) {
      if (!dateVal) return null;

      const [day, month, year] = dateVal.split('/');
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    },

    getData() {
      this.$store.commit('merchantManagement/setFlashErrorMessage', '');
      const { page, itemsPerPage, sortBy, sortDesc } = this.options;
      this.$store
        .dispatch('merchantManagement/fetchUsers', {
          date,
          page,
          itemsPerPage,
          sortBy,
          sortDesc,
          search: this.search,
        })
        .then(() => {
          if (this.totalPage < page) {
            if (this.totalPage === 0) {
              this.options.page = 1;
            } else {
              this.options.page = this.totalPage;
            }
          }
        });
    },

    viewItem(item) {
      this.$router.push({ path: `/merchant-management/${item.id}` });
    },

    editItem(item) {
      this.view = false;
      const newItem = { ...item, user: { id: item.id } };
      this.editedIndex =
        this.$store.state.merchantManagement.allUsers.indexOf(item);
      this.editedItem = { ...newItem };
      this.dialog = true;
    },

    close() {
      this.resetUniqueValidation();
      this.view = false;
      this.dialog = false;
      this.$nextTick(() => {
        this.editedItem = { ...this.defaultItem };
        this.editedIndex = -1;
      });
      this.selectedRow = '';
    },

    resetUniqueValidation() {
      this.$store.commit('merchantManagement/clearErrors');
    },

    async save() {
      this.$store.commit('merchantManagement/setFlashErrorMessage', '');
      this.resetUniqueValidation();
      this.$v.$touch();
      if (!this.$v.$invalid) {
        const user = this.editedItem;

        await this.$store
          .dispatch('merchantManagement/updateUser', {
            date,
            user,
            changePassword: !this.changePassword,
            index: this.editedIndex,
          })
          .then((status) => {
            if (status) {
              this.close();
              showAlert(
                this.$store,
                'Update user success !',
                'mdi-check-circle',
                'green'
              );
            } else {
              showAlert(
                this.$store,
                'Error on update user !',
                'mdi-alert',
                'red'
              );
            }
          });
      }
    },
  },
};